module.exports = __webpack_public_path__ + "img/filter.28e34cd6.svg";